var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendQuestions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 -2 20 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-system",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    transform: "translate(-431.000000, -306.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_send_question",
    transform: "translate(429.000000, 304.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.33375,13.66625 L15.33375,13.4575 C15.33375,12.51375 15.9,11.67875 16.77625,11.32875 C17.05125,11.22 17.33625,11.165 17.625,11.165 C18.25125,11.165 18.8575,11.42625 19.28875,11.88125 L20.02625,12.65875 C20.2175,12.34375 20.33375,11.9775 20.33375,11.5825 L20.33375,4.0825 C20.33375,2.9325 19.40125,2 18.25,2 L4.08375,2 C2.9325,2 2,2.9325 2,4.08375 L2,11.58375 C2,12.73375 2.9325,13.6675 4.08375,13.6675 L10.95875,13.6675 L15.33375,13.6675 L15.33375,13.66625 Z M3.66625,5.44125 L3.66625,4.05875 L11.16625,7.55875 L18.66625,4.05875 L18.66625,5.4425 L11.6075,8.73375 C11.46625,8.8 11.31625,8.83375 11.16625,8.83375 C11.01625,8.83375 10.86625,8.8 10.725,8.73375 L3.66625,5.44125 Z",
    id: "Shape",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.82875,16.9875 L18.07875,13.02875 C17.9025,12.8425 17.6325,12.78375 17.39375,12.8775 C17.15625,12.9725 17,13.2025 17,13.45875 L17,15.33375 L10.95875,15.33375 C10.61375,15.33375 10.33375,15.61375 10.33375,15.95875 L10.33375,18.875 C10.33375,19.22 10.61375,19.5 10.95875,19.5 L17,19.5 L17,21.375 C17,21.63125 17.15625,21.86125 17.39375,21.95625 C17.46875,21.985 17.5475,22 17.625,22 C17.7925,22 17.95875,21.9325 18.07875,21.805 L21.82875,17.84625 C22.0575,17.605 22.0575,17.2275 21.82875,16.9875 L21.82875,16.9875 Z",
    id: "Path",
    fill: "#A3C7F6"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendQuestions);
export default __webpack_public_path__ + "static/media/send-questions.97f82decf22c70db66dec1f1424a43b8.svg";
export { ForwardRef as ReactComponent };